import React, { FC } from 'react'
import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import { PLANTS_USP_SKUS } from '@moonpig/web-core-brand/config'
import { ProductModule } from '../types'
import { useProductContext } from '../../../contexts/product'
import { FlowersUSPContent } from './FlowersUSPContent'

export const USPModule: FC<ProductModule> = props => {
  const [{ product }] = useProductContext()

  const isFlowersOrPlants =
    product.category.department === DepartmentsEnum.FLOWERS ||
    product.category.department === DepartmentsEnum.ALL_FLOWERS_AND_PLANTS
  const isPlant = PLANTS_USP_SKUS.includes(product.id)

  if (!isFlowersOrPlants) {
    return null
  }

  return <FlowersUSPContent isPlant={isPlant} {...props} />
}
